import React, { useEffect, useState } from "react";
import useLocales from "../../../hooks/useLocales";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

// Define the base URL for API requests
const baseUrl = process.env.REACT_APP_API_URL;

// CTA (Call to Action) section component
const SubFooter = () => {
  // Initialize localization and navigation utilities
  const { translate } = useLocales();
  const navigate = useNavigate();

  // State for page name input and error handling
  const [pageName, setPageName] = useState("");
  const [pageNameError, setPageNameError] = useState(null);

  // Get user information from Redux store
  const user = useSelector((state) => state?.user?.user);

  // GET STARTED button click handler
  const getStartedHandler = async () => {
    if (user?.token) {
      if (pageName) {
        if (user?.twofactor?.pageName === pageName) {
          setPageNameError(null);
          navigate("/dashboard");
        } else {
          // Set an error message if the entered page name does not match
          setPageNameError({
            value: "pageNameNotMatch",
            message: "Enter Correct Page Name",
          });
        }
      } else {
        setPageNameError(null);
        navigate("/dashboard");
      }
    } else {
      setPageNameError(null);
      if (pageName) {
        await validatePageName(pageName);
      } else {
        navigate("/auth/signUp");
      }
    }
  };

  // Display an error toast if there is a page name mismatch
  useEffect(() => {
    if (pageNameError?.value === "pageNameNotMatch") {
      toast.error(pageNameError?.message);
    }
  }, [pageNameError]);

  // Function to validate the page name using an API call
  const validatePageName = async (pageName) => {
    const data = {
      pageName: pageName,
    };
    const path = "/api/user/validatePageName";
    const url = baseUrl + path;

    try {
      const response = await axios.post(url, data);

      // Redirect to the appropriate page based on the validation result
      if (response.data.status === true) {
        navigate("/auth/signUp");
      } else {
        navigate("/auth/login");
      }
      return response?.data;
    } catch (error) {
      return error;
    }
  };

  // Set the page name when the user is authenticated
  useEffect(() => {
    if (user?.token) {
      setPageName(user?.twofactor?.pageName);
    }
  }, [user]);

  // Render the CTA section
  return (
    <section className="flex justify-center dark:bg-dark-secondary">
      <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full ">
        <div className="px-3 xsmm:px-4 smm:px-5 lg:px-9 py-20 xsmfold:py-20 sm:py-28 2xl:py-28 pb-20 xsmfold:pb-20 sm:pb-[92px] 2xl:pb-[92px]">
          <div className="flex flex-col lg:flex-row justify-center items-center gap-4">
            <h5 className="w-full text-custom_h6 sm:text-custom_h5 dark:text-color_v1_dark">
              {translate(
                "front_end_pages.home_page.create_page_section.start_creating_your_exclusive"
              )}
              <br className="xl:block" />
              {translate(
                "front_end_pages.home_page.create_page_section.bilbio"
              )}
              &nbsp;
              <span className="text-main_color">
                {translate(
                  "front_end_pages.home_page.create_page_section.biolink_url"
                )}
              </span>
              &nbsp;
              {translate("front_end_pages.home_page.create_page_section.now")}!
            </h5>
            <div className="w-full">
              <div className="dark:bg-dark-secondary rounded-full p-2 bg-white flex justify-between w-full items-center border border-gray-800 dark:border-color_dark">
                <div className="flex items-center px-1 sm:px-1 xl:px-4 w-full">
                  <p className="text-main_color px-1 whitespace-nowrap text-small2_b sm:text-body_copy1_b md:text-custom_h6">
                    bil.bio/
                  </p>
                  <input
                    type="text"
                    defaultValue={pageName || ""}
                    onChange={(e) => setPageName(e.target.value)}
                    placeholder="your pagename"
                    className="dark:text-color_v1_dark dark:caret-white placeholder:dark:text-color_v1_dark dark:bg-dark-secondary focus:outline-none placeholder:text-heading_color text-small2 sm:text-body_copy1 md:text-custom_h6r xsmm:px-0 xsml:px-1 px-1 w-full"
                  />
                </div>
                <div
                  onClick={getStartedHandler}
                  className="cursor-pointer rounded-full whitespace-nowrap px-[26px] pt-[9px] pb-[8px] sm:px-10 sm:pt-[13px] sm:pb-[12px] lg:px-10 lg:pt-[17px] lg:pb-[16px] text-white bg-main_color text-small2_b sm:text-small1_bold lg:text-body_copy2_b"
                >
                  {translate(`descriptions.get_started`)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubFooter;
